import { render, staticRenderFns } from "./customer-types-form.vue?vue&type=template&id=1e3f169a&scoped=true"
import script from "./customer-types-form.vue?vue&type=script&lang=js"
export * from "./customer-types-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3f169a",
  null
  
)

export default component.exports